import module from '../module';
import * as _ from 'lodash';

module.directive('cartonomyCart', [
    'CartService', 'ConfigurationService','Session', '$translate',
    function (cartService, ConfigurationService,sessionService, $translate) {
        function toPossessiveString(name) {
            if (name[name.length - 1] == 's') {
                return `${name}'`;
            }

            return `${name}'s`;
        }

        return {
            template: require('../views/cartDirective.pug'),
            link: async (scope, element, attributes) => {
                scope.isMobile = () => (/ios|iphone|android/gi).test(navigator.userAgent);

                let orderExists = await cartService.isGroupOrder();
                let cart = await cartService.getCart();

                if (orderExists) {
                    let cartOwner = _.find(cart.participants, participant => participant.status === `OWNER` || (sessionService.getStealthUserMode() && participant.status === `REMOVED`));
                    scope.groupCartButtonText = `${$translate.instant('client.add_to')} ${toPossessiveString(cartOwner && cartOwner.name)} ${$translate.instant('client.header.group_cart')}`;
                }
                else {
                    scope.groupCartButtonText = $translate.instant(`client.cart.group_add`);
                }
            }
        };
    }]);


// WEBPACK FOOTER //
// ./src/modules/cart/directives/CartDirective.js